export default "The Grade Submissions System is now closed for the November 2021 series.\n";